/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cohort-selection-modal-window .modal-dialog{max-width:800px}.cohort-selection-modal-window .modal-dialog .modal-content{height:600px;border-radius:16px}.cohort-selection-modal{display:block;width:100%;height:100%}.cohort-selection-modal iframe{width:100%;height:100%;border:none}"];
export { styles as styles };
//# sourceMappingURL=cohort-selection-modal.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/cohort/cohort-selection-modal/cohort-selection-modal.component.scss.ngstyle.js
// module id = 1336
// module chunks = 27 28 29